'use client';

import { c as _c } from "react/compiler-runtime";
import { ErrorServiceUnavailable } from '@/components/common/Error';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary';
import { ResponsiveDashboardContextProvider } from '@/contexts/Dashboard/Dashboard.context';
import { useIsMedium } from '@/hooks/useBreakpoints';
import { DashboardHero } from '../DashboardHero';
import DashboardHeroTitle from '../DashboardHeroTitle';
import { useEarnPositionsTotals } from '../hooks/useDashboardTotals';
import DashboardEarnPositionsDesktopView from './DashboardEarnPositionsDesktopView';
import DashboardEarnPositionsMobileView from './DashboardEarnPositionsMobileView';
import { useDashboardEarnPositionsTable } from './hooks/useDashboardEarnPositionsTable';
import DashboardEarnPositionsEmptyState from './states/DashboardEarnPositionsEmptyState';
import DashboardEarnPositionsSkeleton from './states/loading/DashboardEarnPositionsSkeleton';
const DashboardEarnPositions = () => {
  const $ = _c(20);
  const isMobile = useIsMedium();
  const {
    earnPositions,
    earnPositionsTableRows,
    facets,
    partial,
    loading,
    error,
    isNotFound,
    table,
    filters,
    handleFiltersChange,
    positionChainIds,
    columnLabels
  } = useDashboardEarnPositionsTable();
  const {
    hasNoPositions
  } = useEarnPositionsTotals(earnPositionsTableRows, isNotFound);
  const unavailable = Boolean(error) || partial && earnPositions.length === 0;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DashboardHeroTitle title="Vaults" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ResponsiveDashboardContextProvider><div className="flex flex-col gap-12">{t0}<SectionErrorBoundary fallback={null} section="DashboardEarnHero" route="/portfolio"><DashboardHero /></SectionErrorBoundary></div></ResponsiveDashboardContextProvider>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== partial || $[3] !== unavailable) {
    t2 = partial && !unavailable ? <p data-testid="dashboard-earn-positions-partial-notice" className="text-secondary-foreground text-sm">Some positions could not be loaded, so this list and its totals may be incomplete.</p> : null;
    $[2] = partial;
    $[3] = unavailable;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== columnLabels || $[6] !== earnPositions || $[7] !== facets || $[8] !== filters || $[9] !== handleFiltersChange || $[10] !== hasNoPositions || $[11] !== isMobile || $[12] !== loading || $[13] !== positionChainIds || $[14] !== table || $[15] !== unavailable) {
    t3 = unavailable ? <ErrorServiceUnavailable /> : loading ? <DashboardEarnPositionsSkeleton /> : hasNoPositions ? <DashboardEarnPositionsEmptyState /> : isMobile ? <DashboardEarnPositionsMobileView table={table} filters={filters} onFiltersChange={handleFiltersChange} positionChainIds={positionChainIds} loading={loading} disabled={false} totalPositionsCount={earnPositions.length} facets={facets} /> : <DashboardEarnPositionsDesktopView table={table} filters={filters} onFiltersChange={handleFiltersChange} positionChainIds={positionChainIds} columnLabels={columnLabels} earnPositions={earnPositions} loading={loading} disabled={false} facets={facets} />;
    $[5] = columnLabels;
    $[6] = earnPositions;
    $[7] = facets;
    $[8] = filters;
    $[9] = handleFiltersChange;
    $[10] = hasNoPositions;
    $[11] = isMobile;
    $[12] = loading;
    $[13] = positionChainIds;
    $[14] = table;
    $[15] = unavailable;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t2 || $[18] !== t3) {
    t4 = <div className="flex flex-col gap-12">{t1}{t2}{t3}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};
export default DashboardEarnPositions;